import React from 'react';
import { MoonIcon } from 'lucide-react';
import { painPoints } from '../data/content';
import { toneAt } from '../utils/iconTones';
import { Accent, SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
export function ProblemSection() {
  return <section className="w-full bg-steel-950 px-6 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-157" data-mp="30j0wlgv3h18d">
      <div className="mx-auto max-w-6xl" data-id="element-158" data-mp="2voo6wp30yto6">
        <SectionHeading id="problem-title" badge="The Sunday Night Problem" badgeIcon={MoonIcon} title={<>
              Are you spending your weekends <Accent data-id="element-160" data-mp="35idedn73zi43">building slide decks</Accent> from scratch?
            </>} subtitle="Let's be honest: being a technical instructor is two full-time jobs — mastering industrial physics and automation, and designing curriculum full time. You want to give your students the best, but the industry moves too fast." data-id="element-159" data-mp="39gunude054oo" />

        <ul className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-161" data-mp="1k2xxav97i63q">
          {painPoints.map(({
          icon: Icon,
          title,
          description
        }, index) => <Reveal as="li" key={title} index={index} className="h-full" data-id="element-162" data-mp="jey8i2b7g3vi" data-mpi={index}>
              <div className="flex h-full flex-col border border-white/[0.07] bg-steel-900 p-5 transition-[transform,border-color] duration-150 ease-out hover:-translate-y-0.5 hover:border-ember-500/40" data-id="element-163" data-mp="oczrkn8ms36z">
                <div className="flex items-center gap-3" data-id="element-164" data-mp="x5behz4jd8i7">
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-sm ${toneAt(index).bg}`} data-id="element-165" data-mp="123v181qyeobm">
                    <Icon className={`h-4 w-4 ${toneAt(index).fg}`} aria-hidden="true" data-id="element-166" data-mp="171mv31b5skig" />
                  </span>
                  <h3 className="font-display text-base font-semibold uppercase tracking-wide text-ink-50" data-id="element-167" data-mp="1c33t8p29dsvc">
                    {title}
                  </h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-ink-400" data-id="element-168" data-mp="3dtxhs1u85kfh">{description}</p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal className="mt-10 flex justify-center" data-id="element-169" data-mp="3hv0s68ti6o9b">
          <p className="font-display text-2xl font-semibold uppercase tracking-wide text-ink-50 sm:text-3xl" data-id="element-170" data-mp="ozh6gjh07gpu">
            Stop struggling. <span className="text-ember-400" data-id="element-171" data-mp="k2qr5yd0wp5h">Start teaching.</span>
          </p>
        </Reveal>
      </div>
    </section>;
}